export default "__VITE_ASSET__Cjesxt1i__"